<div class="p-grid">
    <div class="p-col-9 p-m-auto">
        <div class="card">
            <p-steps styleClass="steps-custom" [model]="items" [readonly]="false" [activeIndex]="indiceActivo"></p-steps>
        </div>

        <dum-registro-usuario-publico
        [newUser]="usuarioNuevo"
         *ngIf="mostrar1"
        [hasVehiculo]="hasVehiculo"
          (eventSiguiente)="recibirUsuario($event)"
          (eventHasVehiculo)="eventHasVehiculo($event)"></dum-registro-usuario-publico>
        <dum-registro-vehiculo [vehiculo]="vehiculoNuevo" *ngIf=" mostrar2 " (eventSiguienteVehiculo)="recibirVehiculo($event)" (eventAnteriorToUsuario)="recibirAnteriorUsuario($event)"></dum-registro-vehiculo>
        <dum-registro-documentacion-vehiculo
        *ngIf="mostrar3"
        [documentos]="documentos"
        [newDocumentos]="newDocumentos"
        [isAllDocuments]="isAllDocuments"
        [isVehiculoMenor12TN]="isVehiculoMenor12TN"
        (eventEmitIsAllDocuments)="getIsAllDocuments($event)" (eventSiguienteArchivos)="recibirArchivos($event)"
            (eventSiguienteDocumentos)="recibirDocumentacion($event)" (eventAnteriorToVehiculo)="recibirAnteriorVehiculo($event)"></dum-registro-documentacion-vehiculo>
        <div *ngIf="mostrarFinalizar">
            <p-fieldset legend="Usuario">
                <div class="p-grid">
                    <div class="p-col-6">
                        <b>{{'GLOBAL.NOMBRE' |translate}}:</b> {{usuarioNuevo.nombre}}
                    </div>
                    <div class="p-col-6">
                        <b>{{'GLOBAL.APELLIDOS' |translate}}:</b> {{usuarioNuevo.apellido}}
                    </div>
                </div>
                <div class="p-grid">
                    <div class="p-col-6">
                        <b>{{'GLOBAL.NIF'|translate}}:</b> {{usuarioNuevo.nif}}
                    </div>
                    <div class="p-col-6">
                        <b>{{'GLOBAL.USUARIO' |translate}}:</b> {{usuarioNuevo.usuario}}
                    </div>
                </div>
                <div class="p-grid">
                    <div class="p-col-6">
                        <b>{{'GLOBAL.TELEFONO' |translate}}:</b> {{usuarioNuevo.telefono}}
                    </div>
                    <div class="p-col-6">
                        <b>{{'GLOBAL.EMAIL' |translate}}:</b> {{usuarioNuevo.email}}
                    </div>
                </div>
            </p-fieldset>
            <p-fieldset legend="Vehiculo" *ngIf="vehiculoNuevo.matricula">
                <div class="p-grid">
                    <div class="p-col-6"><b>{{'VEHICULO.MATRICULA' |translate }}:</b> {{vehiculoNuevo.matricula}}</div>
                    <div class="p-col-6"><b>{{'VEHICULO.TIPO' |translate}}:</b> {{vehiculoNuevo.tipoVehiculo.nombre}}</div>
                </div>
                <div class="p-grid">
                    <div class="p-col-6"><b>{{'VEHICULO.PESO' |translate}}:</b> {{vehiculoNuevo.peso}}</div>
                    <div class="p-col-6"><b>{{'VEHICULO.DISTINTIVO.AMBIENTAL' |translate}}:</b> {{vehiculoNuevo.distintivoAmbiental.nombre}}</div>
                </div>
                <div class="p-grid">
                    <div class="p-col-6"><b>{{'VEHICULO.CLASIFICACION' |translate}}:</b> {{vehiculoNuevo.clasificacionVehiculo.nombre}}</div>
                    <div class="p-col-6"><b>{{'VEHICULO.TIPO.COMBUSTIBLE' |translate}}:</b> {{vehiculoNuevo.tipoCombustible.nombre}}</div>
                </div>
                <div class="p-grid">
                    <div class="p-col-6"><b>{{'VEHICULO.USO' |translate}}:</b> {{vehiculoNuevo.usoVehiculo.nombre}}</div>
                    <div *ngIf="vehiculoNuevo.sector !== null" class="p-col-6"><b>{{'VEHICULO.SECTOR' |translate}}:</b> {{vehiculoNuevo.sector.nombre}}</div>
                </div>
            </p-fieldset>
            <p-fieldset legend="Documentación" *ngIf="documentos.length > 0">
                <div class="p-grid" *ngFor="let documento of documentos">
                    <div class="p-col-4">{{documento.tipoDocumento.nombre}}</div>
                    <div class="p-col-4">{{documento.fechaVencimiento}}</div>
                    <div class="p-col-4">
                        <span *ngFor="let img of documento.imagen">{{img.nombre}}<br/></span>
                    </div>
                </div>
            </p-fieldset>
            <button class="pr-2 pl-2 pb-1 pt-1" pButton [label]="'GLOBAL.FINALIZAR' | translate" (click)="saveUser()"></button>
        </div>

        <dum-toast #dumToast></dum-toast>
    </div>
</div>
